import {SimpleStringComparator} from './SimpleStringComparator';

class NameComparator extends SimpleStringComparator {
    constructor() {
        super();
    }
}

export {NameComparator};
